import { css } from '@utils/css';

const iframe = css`
  display: block;
`;

export { iframe };
//# sourceMappingURL=iframe.js.map
